import { createActionGroup, emptyProps } from '@ngrx/store';

export const versionEffectsActions = createActionGroup({
  source: 'versionEffects',
  events: {
    'New Version Is Available': emptyProps(),
  },
});
